import React, { Component, PropTypes } from 'react';
import { Deck, Slide } from 'spectacle-ppa';
import StartLevel from 'components/startLevel';

import prep from './sections/00_prep/prepSection';

export default class extends Component {

  static propTypes = {
    nextLevel: PropTypes.string.isRequired,
    configuration: PropTypes.string
  };

  static contextTypes = {
    regionData: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  render () {
    const { nextLevel: level, configuration } = this.props;
    const { regionData, i18n } = this.context;
    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {/* Prep */}
        {prep({ level, configuration, regionData, i18n })}

        <Slide
            id="start"
            textColor="white">
          <StartLevel />
        </Slide>

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/keepCool/levelPrep.jsx